import React from 'react';
import { Image, Label } from 'semantic-ui-react';
import { collectionLogoEndpoint, collectionUrl } from '@/constants/urls';

const hideElement = (el) => {
  const element = el;
  element.target.style.display = 'none';
};

const CollectionLabel = ({
  collection,
  showLogo = true,
  asLink = true,
}) => (
  <Label
    {...(showLogo && { image: true })}
    {...(asLink && { as: 'a' })}
    {...(asLink && { href: collectionUrl(collection, '#') })}
  >
    {showLogo && (
    <Image
      key={collection.imageKey}
      src={collectionLogoEndpoint(collection.code)}
      alt={collection.name}
      onError={(e) => {
        hideElement(e);
      }}
    />
    )}
    {collection.name}
  </Label>
);

export default CollectionLabel;
